import React from 'react'
import "../styles/remodal.css"
import "../styles/remodal-default-theme.css"
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const GroupFamilyModal = (props) => {
    const { toggle, isOpen, setFamilyModalClicked, lang } = props

    const closeBtn = (
        <button className="modal-close" onClick={toggle} type="button">
            &times;
        </button>
    )

    return (
        <div class="overlay" hidden={!isOpen}>
            <Modal className="group-fam-modal" isOpen={isOpen} toggle={toggle}>
                {/* <button class="close" type="button" onClick={toggle}></button> */}

                <ModalHeader
                    className="border-bottom-0"
                    toggle={toggle}
                    close={closeBtn}
                />
                <h3>
                    {lang.groupFamilyModal.modalHeader}
                </h3>

                <ModalBody>
                    <div class="group-select-wrapper">
                        <div class="group-select">
                            <div class="group-select-img">
                                <img
                                    src={"/cimb/securetravel/images/sectravel-family.jpg"}
                                    alt="Family Plans"
                                />
                            </div>

                            <div class="group-select-content">
                                <h4>
                                    {lang.groupFamilyModal.familyPlan}
                                </h4>
                                {lang.groupFamilyModal.familyPlanDesc}
                                <button
                                    class="group-select-btn"
                                    type="button"
                                    onClick={() =>
                                        setFamilyModalClicked({
                                            modalClicked: true,
                                            travelPackage: "family",
                                        })
                                    }
                                >
                                    <div class="btntxt">
                                        {lang.groupFamilyModal.getQuote}
                                        <br />
                                        <span class="RedTxt">
                                            {lang.groupFamilyModal.familyPlans}
                                        </span>
                                    </div>
                                    <div class="btnarrow"></div>
                                </button>
                            </div>
                        </div>

                        <div class="group-select">
                            <div class="group-select-img">
                                <img
                                    src={"/cimb/securetravel/images/sectravel-group.jpg"}
                                    alt="Group Plans"
                                />
                            </div>

                            <div class="group-select-content">
                                <h4>
                                    {lang.groupFamilyModal.groupPlan}
                                </h4>
                                {lang.groupFamilyModal.groupPlanDesc}
                                <button
                                    class="group-select-btn"
                                    type="button"
                                    onClick={() =>
                                        setFamilyModalClicked({
                                            modalClicked: true,
                                            travelPackage: "group",
                                        })
                                    }
                                >
                                    <div class="btntxt">
                                        {lang.groupFamilyModal.getQuote}
                                        <br />
                                        <span class="RedTxt">
                                            {lang.groupFamilyModal.groupPlans}
                                        </span>
                                    </div>
                                    <div class="btnarrow"></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default GroupFamilyModal